
import React, { useState, useEffect } from 'react';
import { influencerService } from '../services/influencerService';
import { Influencer } from '../types';
import { Sparkles, X, Star, Zap } from 'lucide-react';

interface Props {
  influencerId: string;
}

const InfluencerBadge: React.FC<Props> = ({ influencerId }) => {
  const [influencer, setInfluencer] = useState<Influencer | null>(null);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const inf = influencerService.getInfluencerById(influencerId);
    if (inf) {
      setInfluencer(inf);
      // Store in session for checkout attribution
      sessionStorage.setItem('lynqar_attribution_id', influencerId);
    }
  }, [influencerId]);

  if (!influencer || !isVisible) return null;

  return (
    <div className="fixed top-24 left-6 z-[80] animate-in slide-in-from-left-10 fade-in duration-700">
      <div className="bg-white/80 backdrop-blur-xl border border-purple-200 shadow-2xl rounded-[2rem] p-5 flex items-center gap-5 ring-1 ring-purple-500/10">
        <div className="w-14 h-14 rounded-2xl bg-purple-600 flex items-center justify-center text-white shrink-0 shadow-lg shadow-purple-200 group">
          <Zap className="h-6 w-6 animate-pulse" />
        </div>
        <div className="min-w-0 pr-4">
          <div className="flex items-center gap-2 mb-0.5">
             <span className="text-[9px] font-black uppercase tracking-widest text-purple-600">Curated Choice</span>
             <Sparkles className="h-2 w-2 text-amber-500" />
          </div>
          <p className="text-sm font-black text-gray-900 leading-tight">
            Shopping with <span className="text-purple-600">@{influencer.handle}</span>
          </p>
          <p className="text-[8px] text-gray-400 font-bold uppercase mt-1 tracking-tighter italic">"Bhai, ye collection mere top tech picks hain!"</p>
        </div>
        <button onClick={() => setIsVisible(false)} className="p-2 hover:bg-gray-100 rounded-full text-gray-300 hover:text-gray-600 transition-all">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default InfluencerBadge;
